export default function displayWinSchoolDistrictInfo(results) {
    let s = "<h3>School District</h3>";
    let lastatt = "";
    let lastval = ""; 
    if (results.features.length)
        {
                for (let i = 0, il = results.features.length; i < il; i++) {
                    let featureAttributes = results.features[i].attributes;
                    for (let att in featureAttributes) {
                        if (featureAttributes[att])
                            {
                                if (att != lastatt && lastval != featureAttributes[att])
                                {
                                    s += `<table><tr><td><b>${att}:</b> ${featureAttributes[att]}</td></tr></table>`
                                }
                                lastatt = att; 
                                lastval = featureAttributes[att];

                            }
                    }
                }

        }
    else {
        s+= "<p>No school district data found.</p>";
    }
    return s;
}